import { PgAppFormTemplateComponent } from '../pg-app-form-template.component';

import {
  Renderer2,
  ElementRef,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { Platform } from '@angular/cdk/platform';
// import { PgPlatformService } from '../../../core/platform/pg-platform.service';
// import { DOMUtilService } from '../../../core/dom/dom-util.service';

export function getNativeElement(
  element: ElementRef | HTMLElement | ViewContainerRef | ComponentRef<any> | any
): HTMLElement {
  if (element instanceof ElementRef) {
    return element.nativeElement;
  } else if (element instanceof HTMLElement) {
    return element;
  } else if (element && element.nativeElement) {
    return element.nativeElement;
  } else {
    return element;
  }
}

export function getElementHeight(el: any) {
  return getNativeElement(el).offsetHeight;
}

export interface PageLayoutStrategy {
  reconcilePageLayout(): Promise<any>;
}

export abstract class PageLayoutExecutor {
  private _timeout = 150;
  constructor(
    public template: PgAppFormTemplateComponent,
    public renderer: Renderer2,
    public platform: Platform
  ) {}
  // abstract setTopbarSpacerHeight(height);
  abstract setContentMinHeight(height);
  abstract setContentTopOffset(height);
  abstract setFooterSpacerHeight(height);
  abstract resetSectionModifiers();
  reconcilePageLayout() {
    return new Promise((res, rej) => {
      const fn = () => {
        const topbarHeight = getElementHeight(this.template.topbar.elementRef);
        const sectionHeight = getElementHeight(this.template.sectionWrapper);
        const footerHeight = getElementHeight(this.template.footer);

        this.setContentMinHeight(topbarHeight);
        this.setContentTopOffset(sectionHeight);
        this.setFooterSpacerHeight(footerHeight);
        this.resetSectionModifiers();
        this._timeout = 0;
        res();
      };

      // Rule 3: Web development is not a hard science
      // The timeout below is a guess that seems to work in most
      // cases.

      // The timeout exists because when reconciling the layout
      // we may not have the whole page fully rendered which
      // will cause significant miscalculations on the heights
      // which we rely on.
      // The good news is, we should only need it once per instance
      // Since after all the content has loaded once, future
      // height calculations will be primed and ready to go!
      setTimeout(() => fn(), this._timeout);
    });
  }
}

export class LargeViewportLayoutStrategy extends PageLayoutExecutor
  implements PageLayoutStrategy {
  constructor(public template: PgAppFormTemplateComponent) {
    super(template, template.renderer, template.platform);
  }

  setContentMinHeight(topbarHeight) {
    this.renderer.setStyle(
      this.template.contentWrapper.nativeElement,
      'min-height',
      `calc(100vh - ${topbarHeight}px)`
    );
  }

  setContentTopOffset(height) {
    this.renderer.setStyle(
      this.template.contentWrapper.nativeElement,
      'top',
      `0px`
    );
  }

  setFooterSpacerHeight(height) {
    this.renderer.setStyle(
      this.template.footerSpacer.nativeElement,
      'height',
      `${height}px`
    );
  }

  resetSectionModifiers() {
    this.template.sectionOpacity = 1;
    this.template.sectionScale = 1;
  }
}

export class SmallViewportLayoutStrategy extends PageLayoutExecutor
  implements PageLayoutStrategy {
  constructor(public template: PgAppFormTemplateComponent) {
    super(template, template.renderer, template.platform);
  }

  setContentMinHeight(topbarHeight) {
    this.renderer.setStyle(
      this.template.contentWrapper.nativeElement,
      'min-height',
      `calc(100vh - ${topbarHeight}px)`
    );
  }

  setContentTopOffset(sectionHeight) {
    this.renderer.setStyle(
      this.template.contentWrapper.nativeElement,
      'top',
      `${sectionHeight}px`
    );
  }
  setFooterSpacerHeight(height) {
    this.renderer.setStyle(
      this.template.footerSpacer.nativeElement,
      'height',
      `${height}px`
    );
  }

  resetSectionModifiers() {}
}
